import { StorageContext } from "@pulse/contexts/storageContext";
import { ModalContext } from "@pulse/contexts/modalContext";

import { useContext } from "react";

const useStorage = () => useContext(StorageContext);

const useModal = () => {
    const context = useContext(ModalContext);
    if (context === undefined) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};

export { useStorage, useModal };
